import { useSelector } from 'react-redux';
import { includes } from 'lodash';

import { ClaimStatuses } from '@models/InsuranceClaim';
import { selectIsFrontline, selectIsInsurer } from '@components/Auth';
import { CarClaim } from '@models/CarClaim';
import { CancerClaim } from '@models/CancerClaim';
import { PersonalAccidentClaim } from '@models/PersonalAccidentClaim';
import { HealthClaim } from '@models/HealthClaim';

type Prop = CarClaim | CancerClaim | PersonalAccidentClaim | HealthClaim | undefined | null;

export const useEditable = (claimable: Prop) => {
  const isFrontline = useSelector(selectIsFrontline);
  const isInsurer = useSelector(selectIsInsurer);
  const allowedStatuses =
    claimable &&
    includes(
      [ClaimStatuses.Pending, ClaimStatuses.InReview, ClaimStatuses.InProgress, ClaimStatuses.SettlementOffered],
      claimable.status
    );

  return (isFrontline || isInsurer) && allowedStatuses;
};

export const useCanRequestDocuments = () => {
  const isFrontline = useSelector(selectIsFrontline);
  const isInsurer = useSelector(selectIsInsurer);
  return isFrontline || isInsurer;
};
